const {getStore, dispatch, connectModelRedux} = require('od-modules/secure_store/store');

let subscriptions = [];
const store = {
    getState: getStore,
    dispatch(...args) {
        // Add logic for custom actions or dispatch the action
        dispatch(...args);
    },
    subscribe(cb) {
        subscriptions.push(cb);
    },
    unsubscribe(cb) {
        subscriptions = subscriptions.filter((subscription) => subscription !== cb);
    },
};

const notify = () => {
    subscriptions.forEach((cb) => cb(getStore()));
};

const fakeModel = {
    selectors: [],
    onStoreChange() {
        notify();
    },
    trigger() {},
};

connectModelRedux(fakeModel);

module.exports = store;


